<template>
  <div class="progressbar-container">
    <div
      v-for="(percentage, index) in percentages"
      :key="index"
      class="progressbar">
      <div class="progressbar__track">
        <div
          class="progressbar__fill"
          :class="`progressbar__fill--${index}`"
          :style="calculateBarStyle(percentage)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBars",
  props: {
    percentages: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    calculateBarStyle(percentage) {
      let progressWidth = percentage
      if (isNaN(progressWidth))
        progressWidth = 0
      return {
        '--progress-width': `${progressWidth}%`
      };
    },
  },
};
</script>
